import { ICellRendererParams } from 'ag-grid-community'
import { UserType } from 'types'

const userName = (
  props: ICellRendererParams<{
    user: { email: string; firstname: string; lastname: string; type: UserType[] }
  }>,
) => {
  const { firstname, lastname } = props?.data?.user || {}
  return `${firstname} ${lastname}`
}

export default userName
